// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import * as z from 'zod';
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { trackingDataSchema } from '@/tracking/api/types';

const shipmentTrackingResponseSchema = z.object({
  data: trackingDataSchema,
  metadata: responseMetadataSchema,
});

type ShipmentTrackingResponse = z.infer<typeof shipmentTrackingResponseSchema>;

/**
 * Retrieves tracking data for a given shipment
 *
 * @param shipmentKey - Unique identifier of the shipment
 * @returns Promise resolving to the tracking data and request metadata
 * @throws Will throw an error if the API request fails or if the response data is invalid
 */
export async function getShipmentTracking(
  shipmentKey: string
): Promise<ShipmentTrackingResponse> {
  const url = `/v1/shipment/${shipmentKey}/tracking`;
  const response = await api.get(url);
  return parseResponse(shipmentTrackingResponseSchema, response.data, {
    schemaName: 'ShipmentTracking',
    endpoint: url,
  });
}
